









































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Home extends Vue {
    @Prop(String) public header!: string;
    @Prop(Number) public rating!: number;
    @Prop({ default: () => [] }) public imgs!: any[];
    @Prop(String) public content!: string;
}
